var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"acomodar"},[_c('Topas',{staticClass:"text-center mt-3"}),_c('multiplataforma',{staticClass:"mt-2 pb-3"}),(_vm.permisoVisualizador != 11 && _vm.Trabacceso == 1)?_c('dashboardPrincipal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }